// Friendly names of all coordinate reference systems used in Kura.
const epsgListing = {
  "EPSG:3067": "ETRS-TM35FIN",
  "EPSG:3873": "ETRS-GK19",
  "EPSG:3874": "ETRS-GK20",
  "EPSG:3875": "ETRS-GK21",
  "EPSG:3876": "ETRS-GK22",
  "EPSG:3877": "ETRS-GK23",
  "EPSG:3878": "ETRS-GK24",
  "EPSG:3879": "ETRS-GK25",
  "EPSG:3880": "ETRS-GK26",
  "EPSG:3881": "ETRS-GK27",
  "EPSG:3882": "ETRS-GK28",
  "EPSG:3883": "ETRS-GK29",
  "EPSG:3884": "ETRS-GK30",
  "EPSG:3885": "ETRS-GK31",
  "EPSG:2391": "KKJ-kaista 1",
  "EPSG:2392": "KKJ-kaista 2",
  "EPSG:2393": "KKJ-kaista 3 (YKJ)",
  "EPSG:2394": "KKJ-kaista 4",
  "EPSG:3387": "KKJ-kaista 5",
};

export default epsgListing



// WEBPACK FOOTER //
// ./src/config/epsgListing.js